export function parseProposalDateMs(value) {
  const milliseconds = Date.parse(value);
  return Number.isFinite(milliseconds) ? milliseconds : 0;
}

export function normalizeProposalNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function parseProposalSummary(summary) {
  if (typeof summary !== 'string' || !summary.trim()) {
    return {
      sizeKw: null,
      yearly: null,
      savings: null,
      cost: null
    };
  }
  const values = summary.split(',').slice(0, 4).map(normalizeProposalNumber);
  return {
    sizeKw: values[0] ?? null,
    yearly: values[1] ?? null,
    savings: values[2] ?? null,
    cost: values[3] ?? null
  };
}

export function sortProposalsNewestFirst(proposals) {
  return [...proposals].sort(
    (left, right) =>
      parseProposalDateMs(right.createdAt) - parseProposalDateMs(left.createdAt)
  );
}

export function removeProposalRows(proposals, rows) {
  const ids = new Set(rows.map(({ id }) => id));
  return proposals.filter(({ id }) => !ids.has(id));
}

export function appendProposal(proposals, proposal) {
  return sortProposalsNewestFirst([...proposals, proposal]);
}

export function setExclusiveProposalState(proposals, selectedIndex, nextState) {
  if (
    selectedIndex < 0 ||
    selectedIndex >= proposals.length ||
    proposals[selectedIndex]?.state === nextState
  ) {
    return proposals;
  }
  return proposals.map((proposal, index) => ({
    ...proposal,
    state:
      index === selectedIndex
        ? nextState
        : proposal.state === nextState
          ? null
          : proposal.state
  }));
}
